import AppBar from "@material-ui/core/AppBar";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import Link from "@material-ui/core/Link";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import React, { Component, Fragment } from "react";
import { Event, Timing } from "../tracking";



// DialogIframe
// Creates a full screen 'dialog' containing an iframe
// Current use is specific to the reading components

class DialogIframe extends Component {
  state = { isQuizBoxOpen: false, isAlertBoxOpen: false, timeOpen: 0 };

  render() {
    const closeQuizBox = () => {
      this.setState({ isAlertBoxOpen: true });
    };

    const closeAlertBox = () => {
      this.setState({ isAlertBoxOpen: false });
    };

    const closeReading = () => {
      this.setState({ isAlertBoxOpen: false, isQuizBoxOpen: false });
      const timeClose = new Date();
      const elapsed = timeClose - this.state.timeOpen;
      const dayId = this.props.dayId || "";
      Timing("Reading", dayId, elapsed, this.props.title);
      Event("Activity", "Interact with resource", this.props.title);
    };

    return (
      <Fragment>
        <Link variant="body2" onClick={() => {
          this.setState({ isQuizBoxOpen: true });
          this.setState({ timeOpen: new Date() }); // start timer on open
        }
        }>
          <u>{this.props.children}</u>
        </Link>
        {/* Pop up of quiz */}
        <Dialog
          fullScreen
          open={this.state.isQuizBoxOpen}
          onClose={closeQuizBox}
        >
          <AppBar style={{ position: "relative" }}>
            <Toolbar>
              <IconButton
                edge="start"
                color="inherit"
                onClick={closeQuizBox}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
              <Typography variant="h6">{this.props.title}</Typography>
            </Toolbar>
          </AppBar>
          {/* Quiz body */}
          {/* Nice to have: Perhaps add a progress bar while iframe is loading? */}
          <div className="iframe-container">
            <iframe
              title="General Iframe"
              src={this.props.href}
              frameBorder="0"
              height="100%"
              width="100%"
            />
          </div>
        </Dialog>

        {/* Alert when user closes the quiz */}
        {/* We want to make sure that the user did not accidentally hit the exit button! :) */}
        <Dialog
          open={this.state.isAlertBoxOpen}
          onClose={closeAlertBox}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Are you sure you want to close the resource?"}
          </DialogTitle>
          <DialogActions>
            <Button onClick={closeReading} variant="outlined" color="primary">
              Yes
            </Button>
            <Button onClick={closeAlertBox} variant="contained" color="primary">
              No
            </Button>
          </DialogActions>
        </Dialog>
      </Fragment>
    );
  }
}

// TODO: perhaps use this as a base class that LinkToGoogleFormIframe can inherit
export default DialogIframe;
